import { render, staticRenderFns } from "./CProjectCodePrompt.vue?vue&type=template&id=52959548&"
import script from "./CProjectCodePrompt.vue?vue&type=script&lang=js&"
export * from "./CProjectCodePrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports